<template>
  <div class="position-relative">
    <template>
      <div class="sc-package-select">
        <sc-comparison-table>
          <span class="sc-row-header sc-no-tooltip" slot="rowHeader" :class="doubleRows.install ? 'double': ''">
            <div class="sc-tooltip-label">{{ $t('package_selector.tooltip.label.install_fee') }}</div>
          </span>
          <span class="sc-row-header sc-no-tooltip" slot="rowHeader" :class="doubleRows.tracker ? 'double': ''">
            <div class="sc-tooltip-label">{{ $t('package_selector.tooltip.label.tracking_device') }}</div>
          </span>
          <span class="sc-row-header sc-no-tooltip" slot="rowHeader" :class="doubleRows.can ? 'double': ''">
            <div class="sc-tooltip-label">{{ $t('package_selector.tooltip.label.can_device') }}</div>
          </span>
          <span class="sc-row-header sc-no-tooltip" slot="rowHeader">
            <div class="sc-tooltip-label">{{ $t('package_selector.tooltip.label.data_retention') }}</div>
          </span>
          <span class="sc-row-header sc-no-tooltip" slot="rowHeader">
            <div class="sc-tooltip-label expand" @click="onExpandClick()">
              <i class="sc-icon-plus" v-if="!showAddons"></i>
              <i class="sc-icon-minus" v-if="showAddons"></i>
              <span>{{ $t('package_selector.tooltip.label.available_addons') }}</span>
            </div>
          </span>
          <span v-for="addon in addons" :key="addon.label" class="sc-row-header sc-no-tooltip" slot="rowHeader" v-show="showAddons">
            <div class="sc-tooltip-label">{{ addon.label }}</div>
            <sc-tooltip v-if="addon.tooltip" :icon="'info_outline'" class="sc-tooltip"
                              :text="addon.tooltip"/>
          </span>
          <template slot="column" v-for="(productPackage, index) in packages">
            <sc-comparison-table-column :highlight="index === 1" :key="productPackage.id" class="sc-comparison-column">
              <template #header>
                <div class="sc-table-header">
                  <span>{{ $t('package.group_name.' + productPackage.groupCode) }}</span>
                  <strong class="sc-package-type">{{ $t('package.package_name.' + productPackage.code) }}</strong>
                  <hr/>
                </div>
              </template>
              <template #subheader>
                <div class="sc-showcase-subheader">
                  <span class="price">{{ $price(productPackage.monthlyFee) }}</span>
                  <span class="sub-price">{{ $t('common.per_month_per_vehicle') }}</span>
                  <sc-counter class="sc-counter"
                              :defaultValue="getCounterValueByProduct(productPackage)"
                              :max="counterData.maxValue"
                              :min="counterData.minValue"
                              @increase="counterIncrease($event, productPackage)"
                              @decrease="counterDecrease($event, productPackage)" />
                  <rounded-button class="sc-inline-next-button" :class="index !== 1 ? 'visibility-hidden': 'double-width'" color="outline" @click="onNext()" size="large">{{ $t('common.next') }}</rounded-button>
                </div>
              </template>
              <sc-comparison-table-row slot="row" :class="doubleRows.install ? 'double': ''">
                <span class="sc-labels-mobile sc-only-mobile">{{ $t('package_selector.tooltip.label.install_fee') }}</span>
                <price :value="getInstallationCost(productPackage)"></price>
              </sc-comparison-table-row>
              <sc-comparison-table-row slot="row" :class="doubleRows.tracker ? 'double': ''">
                <span class="sc-labels-mobile sc-only-mobile">{{ $t('package_selector.tooltip.label.tracking_device') }}</span>
                <price :value="getTrackerCost(productPackage)"></price>
              </sc-comparison-table-row>
              <sc-comparison-table-row slot="row" :class="doubleRows.can ? 'double': ''">
                <span class="sc-labels-mobile sc-only-mobile">{{ $t('package_selector.tooltip.label.can_device') }}</span>
                <price :value="getCanDeviceCost(productPackage)"></price>
              </sc-comparison-table-row>
              <sc-comparison-table-row slot="row">
                <span class="sc-labels-mobile sc-only-mobile">{{ $t('package_selector.tooltip.label.data_retention') }}</span>
                <span v-if="!isPlusOrExtraPackage(productPackage)">{{ $t('package_selector.data_retention.2_months') }}</span>
                <span v-if="isPlusPackage(productPackage)">{{ $t('package_selector.data_retention.2_years') }}</span>
                <span v-if="isExtraPackage(productPackage)">{{ $t('package_selector.data_retention.unlimited') }}</span>
              </sc-comparison-table-row>
              <sc-comparison-table-row slot="row">
                <div class="sc-labels-mobile sc-tooltip-label expand sc-only-mobile" @click="onExpandClick()">
                  <i class="sc-icon-plus" v-if="!showAddons"></i>
                  <i class="sc-icon-minus" v-if="showAddons"></i>
                  <span>{{ $t('package_selector.tooltip.label.available_addons') }}</span>
                </div>
                <span>{{ $t('package_selector.num_addons', { num: countPackageAddons(productPackage) }) }}</span>
              </sc-comparison-table-row>
              <sc-comparison-table-row slot="row" v-for="addon in addons" :key="addon.label" v-show="showAddons">
                <div class="sc-labels-mobile sc-labels-mobile-addons sc-only-mobile"><sc-tooltip v-if="addon.tooltip" :icon="'info_outline'" class="sc-tooltip" :text="addon.tooltip"/>{{ addon.label }}</div>
                <span v-if="isCheckAddon(addon, productPackage)"><i class="sc-icon-check"/></span>
                <span v-else></span>
              </sc-comparison-table-row>
            </sc-comparison-table-column>
          </template>
        </sc-comparison-table>
      </div>
      <div class="sc-gift-tools" v-if="trackerOrCanDeviceForFree()"><img class="arrow" src="../../../../public/img/arrow.png">
        <span class="sc-gift-text" v-if="trackerOrCanDeviceForFree() === FreeDevices.BOTH">{{ $t('package_selector.other.arrow_gift_both_free') }}</span>
        <span class="sc-gift-text" v-else-if="trackerOrCanDeviceForFree() === FreeDevices.TRACKER_ONLY">{{ $t('package_selector.other.arrow_gift_tracker_free') }}</span>
        <span class="sc-gift-text" v-else-if="trackerOrCanDeviceForFree() === FreeDevices.CAN_ONLY">{{ $t('package_selector.other.arrow_gift_can_device_free') }}</span>
      </div>
    </template>
    <div class="comments">
      <!-- <div class="first-comment" v-if="showTrackerComment && trackerBasePrice !== null">
        {{ $t('package_selector.other.tracker_gift', { price: $price(trackerBasePrice), loyalty: '2' })}}
      </div> -->
      <!-- <div class="second-comment" v-if="showCanDeviceComment && canBasePrice !== null">
        {{ $t('package_selector.other.CAN_gift', { price: $price(canBasePrice), loyalty: '2' })}}
      </div> -->
      <div class="first-comment" v-if="(showTrackerComment && trackerBasePrice !== null) || (showCanDeviceComment && canBasePrice !== null)">
        {{ $t('package_selector.other.tracker_or_can_gift', { trackerPrice: $price(trackerBasePrice), canPrice: $price(canBasePrice) })}}
      </div>
    </div>
  </div>
</template>

<script>
import {
  ScComparisonTable,
  ScComparisonTableRow,
  ScComparisonTableColumn,
  ScCounter,
  ScTooltip
} from 'smartcommerce-component-library'
import { FreeDevices, ProductAddonCode, PackageCodes } from '../../../shared/utils/ProductEnums'
import { OrderWizardActionTypes as actions } from '../../store/action-types'
import RoundedButton from '../../../shared/components/RoundedButton'
import Price from './Price'

export default {
  name: 'PackageComparisonTable',
  components: {
    ScComparisonTable,
    ScComparisonTableRow,
    ScComparisonTableColumn,
    ScCounter,
    ScTooltip,
    RoundedButton,
    Price
  },

  props: {
    packages: {
      type: Array
    }
  },

  data () {
    return {
      counterData: {
        defaultValue: 0,
        minValue: 0,
        maxValue: 99
      },
      FreeDevices,
      addons: this.$t('package_selector.addons'),
      showAddons: false,
      doubleRows: {
        install: false,
        tracker: false,
        can: false
      }
    }
  },

  methods: {
    isCheckAddon (addon, productPackage) {
      return (addon.matrix.basic && this.isBasicPackage(productPackage)) ||
            (addon.matrix.plus && this.isPlusPackage(productPackage)) ||
            (addon.matrix.extra && this.isExtraPackage(productPackage))
    },

    counterIncrease (number, productPackage) {
      this.$store.dispatch(actions.ADD_TO_CART, { productPackage, quantity: 1 })
      this.$ga && this.$ga.event({
        eventCategory: 'Package',
        eventAction: 'Pageselector'
      })
    },

    counterDecrease (number, productPackage) {
      this.$store.dispatch(actions.REMOVE_FROM_CART, { productPackage, quantity: 1 })
    },

    getCounterValueByProduct (productPackage) {
      return this.$store.getters.getCountOfProductInCart(productPackage)
    },

    getInstallationCost (productPackage) {
      if (!productPackage) return
      let setupFeeAddon = productPackage.findAddon(ProductAddonCode.SETUP_FEE)
      const result = {
        price: null,
        strikethrough: null
      }

      if (setupFeeAddon.setupFee === null) {
        result.price = this.$t('package_selector.number_formats.no_price')
      } else if (setupFeeAddon.setupFee === 0) {
        result.price = this.$t('package_selector.free.installation_cost')
        result.strikethrough = this.$t('package_selector.number_formats.installation_cost', { price: this.$price(setupFeeAddon.baseSetupFee) })
        this.doubleRows.install = true
      } else {
        result.price = this.$t('package_selector.number_formats.installation_cost', { price: this.$price(setupFeeAddon.setupFee) })
      }

      return result
    },

    getTrackerCost (productPackage) {
      if (!productPackage) return
      let trackerAddon = productPackage.findAddon(ProductAddonCode.TRACKER)
      const result = {
        price: null,
        strikethrough: null
      }

      if (trackerAddon === null || trackerAddon.setupFee === null) {
        result.price = this.$t('package_selector.number_formats.no_price')
        return result
      }

      if (trackerAddon.setupFee === 0) {
        result.price = this.$t('package_selector.free.tracker_cost')
        result.strikethrough = this.$t('package_selector.number_formats.tracker_cost', { price: this.$price(trackerAddon.baseSetupFee) })
        this.doubleRows.tracker = true
        return result
      }

      result.price = this.$t('package_selector.number_formats.tracker_cost', { price: this.$price(trackerAddon.setupFee) })
      return result
    },

    getCanDeviceCost (productPackage) {
      if (!productPackage) return
      let canAddon = productPackage.findAddon(ProductAddonCode.CAN_DEVICE)
      const result = {
        price: null,
        strikethrough: null
      }

      if (canAddon === null || canAddon.setupFee === null) {
        result.price = this.$t('package_selector.number_formats.no_price')
        return result
      }

      if (canAddon.setupFee === 0) {
        result.price = this.$t('package_selector.free.can_device_cost')
        result.strikethrough = this.$t('package_selector.number_formats.can_device_cost', { price: this.$price(canAddon.baseSetupFee) })
        this.doubleRows.can = true
        return result
      }

      result.price = this.$t('package_selector.number_formats.can_device_cost', { price: this.$price(canAddon.setupFee) })
      return result
    },

    isPlusOrExtraPackage (productPackage) {
      return this.isPlusPackage(productPackage) || this.isExtraPackage(productPackage)
    },

    isExtraPackage (productPackage) {
      return (PackageCodes.EXTRA.indexOf(productPackage.code) > -1)
    },

    isPlusPackage (productPackage) {
      return (PackageCodes.PLUS.indexOf(productPackage.code) > -1)
    },

    isBasicPackage (productPackage) {
      return (PackageCodes.BASIC.indexOf(productPackage.code) > -1)
    },

    trackerOrCanDeviceForFree () {
      let isTrackerFree = false
      let isCanDeviceFree = false
      this.packages.forEach(productPackage => {
        let canAddon = productPackage.findAddon(ProductAddonCode.CAN_DEVICE)
        let trackerAddon = productPackage.findAddon(ProductAddonCode.TRACKER)
        if (canAddon && canAddon.setupFee === 0) isCanDeviceFree = true
        if (trackerAddon && trackerAddon.setupFee === 0) isTrackerFree = true
      })

      if (isTrackerFree && isCanDeviceFree) {
        return FreeDevices.BOTH
      }

      if (isTrackerFree) {
        return FreeDevices.TRACKER_ONLY
      }

      if (isCanDeviceFree) {
        return FreeDevices.CAN_ONLY
      }
    },

    isShowComment (addonCode) {
      if (!this.packages) return false
      for (let i = 0; i < this.packages.length; i++) {
        let productPackage = this.packages[i]
        let trackerAddon = productPackage.findAddon(addonCode)
        if (trackerAddon && trackerAddon.setupFee === 0) return true
      }

      return false
    },

    findAddonBaseSetupFee (addonCode) {
      if (!this.packages) return null
      for (let i = 0; i < this.packages.length; i++) {
        let productPackage = this.packages[i]
        let addon = productPackage.findAddon(addonCode)
        if (!addon) continue
        let price = addon.baseSetupFee
        if (price !== null) {
          return price
        }
      }
      return null
    },

    onExpandClick () {
      this.showAddons = !this.showAddons
    },

    countPackageAddons (productPackage) {
      return this.addons.reduce((acc, v) => acc + (this.isCheckAddon(v, productPackage) ? 1 : 0), 0)
    },

    onNext () {
      this.$emit('next')
    }
  },

  computed: {
    canBasePrice () {
      return this.findAddonBaseSetupFee(ProductAddonCode.CAN_DEVICE)
    },

    trackerBasePrice () {
      return this.findAddonBaseSetupFee(ProductAddonCode.TRACKER)
    },

    showTrackerComment () {
      return this.isShowComment(ProductAddonCode.TRACKER)
    },

    showCanDeviceComment () {
      return this.isShowComment(ProductAddonCode.CAN_DEVICE)
    }
  },

  watch: {
    packages () {
      this.doubleRows = {
        install: false,
        tracker: false,
        can: false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chip-select {
  margin: 40px auto;
  font-size: 14px;
}

hr {
  width: 80%;
  background-color: #3a6005;
  margin-top: 1em;
  margin-bottom: 1em;
  height: 2px;
  opacity: 0.1;
  border-radius: 4px;
}

.sc-showcase-subheader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em;

  .price {
    color: $sc-primary;
    font-size: 32px;
    font-weight: bold;
  }

  .sc-counter {
    margin-top: 1.5em;
    margin-bottom: 1em;

    /deep/ .sc-counter-button {
      background-color: $primary;
      border: 2px solid $primary;
      color: #ffffff;

      &:hover {
        background-color: #ffffff;
        color: $primary;
      }
    }
  }
}

.sc-table-header {
  display: flex;
  flex-direction: column;
  padding-top: 1em;
  font-weight: 500;

  span {
    color: $text-gray;
    font-size: 14px;
    padding-bottom: 1em;
  }
}

.sc-comparison-table {
  margin: 2em auto 0 auto;
  position: relative;
  float: left;
}

.sc-comparison-table-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5em;
}

.sc-row-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  line-height: 1.93;
  max-width: 210px;
  white-space: nowrap;
  height: 40px;
}

.sc-comparison-column {
  width: 220px;
  color: $sc-primary;
  font-weight: 600;
}

.sc-only-mobile{
  display: none;
}

.sc-package-select {
  margin-left: 1%;
}

i {
  font-size: 30px;
}

.sc-package-type {
  color: $sc-text-dark;
  font-size: 20px;
  text-transform: uppercase;
}

.sub-price {
  color: $text-gray;
  font-size: 14px;
}
.sc-tooltip {
  padding-top: 10px;
  margin: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  .material-icons {
    font-size: 10px;
  }
}
.sc-tooltip-label {
  margin-right: 5px;

  &.expand {
    color: $primary;
    cursor:pointer;
    font-weight: bold;

    i {
      font-size: 24px;
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
      display: inline-block;
    }

    &:hover span {
      text-decoration: underline;
    }
  }
}

.material-icons {
  font-size: 18px;
  margin: 2px 15px 0;
  font-weight: 500;

  .material-icons {
    font-size: $sc-tooltip-icon-font-size;
  }
}

.sc-gift-tools {
  position: absolute;
  right: 30px;
  top: 410px;
  width: 190px;

  .arrow {
    height: 40px;
    width: 30px;
    float: left;
  }

  .sc-gift-text {
    font-size: 14px;
    color: $primary;
    text-align: left;
    vertical-align: top;
  }
}

.comments {
  padding-top: 35px;
  margin-left: 225px;
  color: $text-gray;
  width: 662px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  clear: both;
}

.sc-no-tooltip {
  margin: 0 5px 0 0;
}

/deep/ .sc-tooltip-text {
  white-space: normal;
}

/deep/ .sc-comparison-table-row {
  line-height: 2.5em;
}

/deep/ .sc-comparison-table-row.double, .sc-row-header.double {
  height: 3.5em;
  line-height: 3.5em;
}

@media(max-width: 1295px) {
  .sc-row-header .sc-tooltip-label {
    font-size: 15px;
  }
}

@media(max-width: 1260px) {
  .sc-row-header .sc-tooltip-label {
    font-size: 14px;
  }
}

@media(max-width: 1230px) {
  .sc-row-header .sc-tooltip-label {
    font-size: 13px;
  }
}

@media (max-width: 1199px) {
  .sc-gift-tools {
    right: -125px;
  }
}

@media(max-width: 1025px) {
  .sc-row-header .sc-tooltip-label {
    font-size: 12px;
  }
}

@media(max-width: 768px) {
  .sc-only-mobile{
    display: inline-block;
  }

  .sc-comparison-table{
    display: block;
    float: none;
  }

  .sc-comparison-column {
    display: block;
    width: 100%;
    margin-top: 35px;
  }

  .sc-inline-next-button{
    visibility: visible;
    width: 80%;
  }

  .sc-row-header{
    display: none;
  }

  .sc-comparison-table-row{
    padding: 0px 20px;
    justify-content: space-between;
  }

  .sc-labels-mobile{
    font-size: 13px;
    color: #333;
  }

  .sc-labels-mobile-addons{
    padding-left: 25px;
    position: relative;
  }

  .sc-tooltip{
    position: absolute;
    display: block;
    padding: 0px;
    margin: 0px;
    top: 4px;
    left: 0px;
  }

  /deep/ .sc-comparison-table-row.double{
    line-height: inherit;
    height: 4rem;
  }

  .fit{
    width: inherit;
    height: inherit;
  }

  .sc-gift-tools{
    display: none;
  }

  .comments{
    margin: auto;
    width: 90%;
  }
}
</style>
